import standardisePrice from '../../../../../util/standardisePrice';
import { ISearchAndFilterProductPrice } from '../../../types';

const getProductPrice = (
  sellingPriceMin: number | string,
  sellingPriceMax: number | string,
  listPriceMin: number | string,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  _listPriceMax: number | string
): ISearchAndFilterProductPrice => {
  // Check if B2B customer
  const isB2B = window['theme']?.isb2b === true;
  const b2bMultiplier = 0.4; // 60% off = multiply by 0.4

  let finalPrice: number = standardisePrice(sellingPriceMin);
  let originalPrice: number = standardisePrice(listPriceMin);
  let priceMin: number = standardisePrice(sellingPriceMin);
  let priceMax: number = standardisePrice(sellingPriceMax);

  // Apply B2B discount
  if (isB2B) {
    // Discount the selling prices
    finalPrice = Math.round(finalPrice * b2bMultiplier);
    priceMin = Math.round(priceMin * b2bMultiplier);
    priceMax = Math.round(priceMax * b2bMultiplier);

    // CRITICAL: Set originalPrice = finalPrice so no strikethrough appears
    // B2B customers see discounted price as THE price, not a sale
    originalPrice = finalPrice;
  } else {
    // Non-B2B: Use listPrice as originalPrice for sale detection
    if (originalPrice < 1) {
      originalPrice = finalPrice;
    }
  }

  return {
    originalPrice,
    finalPrice,
    priceMin,
    priceMax
  };
};

export default getProductPrice;
